module.exports = __webpack_public_path__ + "img/full7-min.109457ce.png";